import { render, staticRenderFns } from "./LogoutUser.vue?vue&type=template&id=67088faf&"
import script from "./LogoutUser.vue?vue&type=script&lang=js&"
export * from "./LogoutUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/dostartu.pl/app.startzone.online/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67088faf')) {
      api.createRecord('67088faf', component.options)
    } else {
      api.reload('67088faf', component.options)
    }
    module.hot.accept("./LogoutUser.vue?vue&type=template&id=67088faf&", function () {
      api.rerender('67088faf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/LogoutUser.vue"
export default component.exports